import { deepCopyUtil } from "../util/util";

export interface SquareColors {
  colors: (string | null)[][];
  paintCorner(r: number, c: number, color: string): void;
  getColor(r: number, c: number): string | null;
  equals(other: SquareColors): boolean;
  deepCopy(): SquareColors;
}

export function SquareColors(rows: number, cols: number): SquareColors {
  const that: SquareColors = {
    colors: [],

    paintCorner(r: number, c: number, color: string): void {
      that.colors[r][c] = color;
    },

    getColor(r: number, c: number): string | null {
      return that.colors[r][c];
    },

    equals(other: SquareColors): boolean {
      for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols; j++) {
          if (that.colors[i][j] !== other.colors[i][j]) return false;
        }
      }
      return true;
    },

    deepCopy(): SquareColors {
      const newModel = SquareColors(rows, cols);
      newModel.colors = deepCopyUtil(that.colors);
      return newModel;
    },
  };

  for (let i = 0; i < rows; i++) {
    that.colors[i] = [];
    for (let j = 0; j < cols; j++) {
      that.colors[i][j] = null;
    }
  }

  return that;
}
